/**
 * Middle School Complete Vocabulary - Grade 8 (八年级完整词汇)
 * 核心词汇约400个
 */

import { VocabularyWord } from './vocabulary';

export const grade8Vocabulary: VocabularyWord[] = [
  // D-G 基础词汇继续
  {
    id: 'danger', word: 'danger', phoneticUS: '/ˈdeɪndʒər/', phoneticUK: '/ˈdeɪndʒə/',
    meaning: '危险', example: 'There is danger here.', exampleTranslation: '这里有危险。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⚠️'
  },
  {
    id: 'dangerous', word: 'dangerous', phoneticUS: '/ˈdeɪndʒərəs/', phoneticUK: '/ˈdeɪndʒərəs/',
    meaning: '危险的', example: 'It is dangerous.', exampleTranslation: '这很危险。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '⚠️'
  },
  {
    id: 'dance', word: 'dance', phoneticUS: '/dæns/', phoneticUK: '/dæns/',
    meaning: '跳舞', example: 'She dances well.', exampleTranslation: '她跳舞很好。',
    category: 'hobbies', difficulty: 'easy', grade: '8', level: 'middle', image: '💃'
  },
  {
    id: 'date', word: 'date', phoneticUS: '/deɪt/', phoneticUK: '/deɪt/',
    meaning: '日期', example: 'What is the date today?', exampleTranslation: '今天是几号？',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '📅'
  },
  {
    id: 'daughter', word: 'daughter', phoneticUS: '/ˈdɔtər/', phoneticUK: '/ˈdɔtə/',
    meaning: '女儿', example: 'My daughter is five.', exampleTranslation: '我女儿5岁了。',
    category: 'family', difficulty: 'easy', grade: '8', level: 'middle', image: '👧'
  },
  {
    id: 'day', word: 'day', phoneticUS: '/deɪ/', phoneticUK: '/deɪ/',
    meaning: '白天；天', example: 'Have a good day!', exampleTranslation: '祝你有个好的一天！',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '☀️'
  },
  {
    id: 'dead', word: 'dead', phoneticUS: '/ded/', phoneticUK: '/ded/',
    meaning: '死的', example: 'The tree is dead.', exampleTranslation: '树死了。',
    category: 'nature', difficulty: 'medium', grade: '8', level: 'middle', image: '🥀'
  },
  {
    id: 'deal', word: 'deal', phoneticUS: '/diːl/', phoneticUK: '/diːl/',
    meaning: '处理；交易', example: 'Deal with the problem.', exampleTranslation: '处理问题。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '🤝'
  },
  {
    id: 'death', word: 'death', phoneticUS: '/deθ/', phoneticUK: '/deθ/',
    meaning: '死亡', example: 'Life and death.', exampleTranslation: '生与死。',
    category: 'abstract', difficulty: 'hard', grade: '8', level: 'middle', image: '🖤'
  },
  {
    id: 'decide', word: 'decide', phoneticUS: '/dɪˈsaɪd/', phoneticUK: '/dɪˈsaɪd/',
    meaning: '决定', example: 'I decide to go.', exampleTranslation: '我决定去。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'deep', word: 'deep', phoneticUS: '/diːp/', phoneticUK: '/diːp/',
    meaning: '深的', example: 'The river is deep.', exampleTranslation: '河很深。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🌊'
  },
  {
    id: 'delicious', word: 'delicious', phoneticUS: '/dɪˈlɪʃəs/', phoneticUK: '/dɪˈlɪʃəs/',
    meaning: '美味的', example: 'The food is delicious.', exampleTranslation: '食物很美味。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '😋'
  },
  {
    id: 'describe', word: 'describe', phoneticUS: '/dɪˈskraɪb/', phoneticUK: '/dɪˈskraɪb/',
    meaning: '描述', example: 'Describe the picture.', exampleTranslation: '描述这幅画。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '🖼️'
  },
  {
    id: 'design', word: 'design', phoneticUS: '/dɪˈzaɪn/', phoneticUK: '/dɪˈzaɪn/',
    meaning: '设计', example: 'Design a poster.', exampleTranslation: '设计海报。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '🎨'
  },
  {
    id: 'desk', word: 'desk', phoneticUS: '/desk/', phoneticUK: '/desk/',
    meaning: '桌子', example: 'Sit at your desk.', exampleTranslation: '坐在桌子旁。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '🪑'
  },
  {
    id: 'develop', word: 'develop', phoneticUS: '/dɪˈveləp/', phoneticUK: '/dɪˈveləp/',
    meaning: '发展', example: 'Develop new skills.', exampleTranslation: '发展新技能。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '📈'
  },
  {
    id: 'development', word: 'development', phoneticUS: '/dɪˈveləpmənt/', phoneticUK: '/dɪˈveləpmənt/',
    meaning: '发展', example: 'Economic development.', exampleTranslation: '经济发展。',
    category: 'abstract', difficulty: 'hard', grade: '8', level: 'middle', image: '📊'
  },
  {
    id: 'dictionary', word: 'dictionary', phoneticUS: '/ˈdɪkʃəneri/', phoneticUK: '/ˈdɪkʃənəri/',
    meaning: '字典', example: 'Use a dictionary.', exampleTranslation: '用字典。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '📚'
  },
  {
    id: 'die', word: 'die', phoneticUS: '/daɪ/', phoneticUK: '/daɪ/',
    meaning: '死', example: 'Flowers die in winter.', exampleTranslation: '花在冬天会死。',
    category: 'nature', difficulty: 'medium', grade: '8', level: 'middle', image: '🥀'
  },
  {
    id: 'difference', word: 'difference', phoneticUS: '/ˈdɪfərəns/', phoneticUK: '/ˈdɪfərəns/',
    meaning: '差异', example: 'What is the difference?', exampleTranslation: '有什么差异？',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '≠'
  },
  {
    id: 'different', word: 'different', phoneticUS: '/ˈdɪfərənt/', phoneticUK: '/ˈdɪfərənt/',
    meaning: '不同的', example: 'They are different.', exampleTranslation: '它们不同。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '≠'
  },
  {
    id: 'difficult', word: 'difficult', phoneticUS: '/ˈdɪfɪkəlt/', phoneticUK: '/ˈdɪfɪkəlt/',
    meaning: '困难的', example: 'Math is difficult.', exampleTranslation: '数学很难。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🤔'
  },
  {
    id: 'difficulty', word: 'difficulty', phoneticUS: '/ˈdɪfɪkəlti/', phoneticUK: '/ˈdɪfɪkəlti/',
    meaning: '困难', example: 'I have difficulty.', exampleTranslation: '我有困难。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '😰'
  },
  {
    id: 'dig', word: 'dig', phoneticUS: '/dɪɡ/', phoneticUK: '/dɪɡ/',
    meaning: '挖掘', example: 'Dig a hole.', exampleTranslation: '挖洞。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🕳️'
  },
  {
    id: 'dinner', word: 'dinner', phoneticUS: '/ˈdɪnər/', phoneticUK: '/ˈdɪnə/',
    meaning: '晚餐', example: 'We have dinner at 7.', exampleTranslation: '我们7点吃晚餐。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '🍽️'
  },
  {
    id: 'direct', word: 'direct', phoneticUS: '/dɪˈrekt/', phoneticUK: '/dɪˈrekt/',
    meaning: '直接的；指导', example: 'Go direct to school.', exampleTranslation: '直接去学校。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '➡️'
  },
  {
    id: 'direction', word: 'direction', phoneticUS: '/dɪˈrekʃn/', phoneticUK: '/dɪˈrekʃn/',
    meaning: '方向', example: 'Which direction?', exampleTranslation: '哪个方向？',
    category: 'directions', difficulty: 'easy', grade: '8', level: 'middle', image: '🧭'
  },
  {
    id: 'discover', word: 'discover', phoneticUS: '/dɪˈskʌvər/', phoneticUK: '/dɪˈskʌvə/',
    meaning: '发现', example: 'Discover new things.', exampleTranslation: '发现新事物。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '🔍'
  },
  {
    id: 'discuss', word: 'discuss', phoneticUS: '/dɪˈskʌs/', phoneticUK: '/dɪˈskʌs/',
    meaning: '讨论', example: 'Discuss the plan.', exampleTranslation: '讨论计划。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '💬'
  },
  {
    id: 'discussion', word: 'discussion', phoneticUS: '/dɪˈskʌʃən/', phoneticUK: '/dɪˈskʌʃən/',
    meaning: '讨论', example: 'We have a discussion.', exampleTranslation: '我们进行讨论。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '👥'
  },
  {
    id: 'disease', word: 'disease', phoneticUS: '/dɪˈziːz/', phoneticUK: '/dɪˈziːz/',
    meaning: '疾病', example: 'Prevent disease.', exampleTranslation: '预防疾病。',
    category: 'body', difficulty: 'medium', grade: '8', level: 'middle', image: '🏥'
  },
  {
    id: 'dish', word: 'dish', phoneticUS: '/dɪʃ/', phoneticUK: '/dɪʃ/',
    meaning: '盘子；菜肴', example: 'Wash the dishes.', exampleTranslation: '洗盘子。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '🍽️'
  },
  {
    id: 'dislike', word: 'dislike', phoneticUS: '/dɪˈlaɪk/', phoneticUK: '/dɪˈlaɪk/',
    meaning: '不喜欢', example: 'I dislike rain.', exampleTranslation: '我不喜欢下雨。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '👎'
  },
  {
    id: 'divide', word: 'divide', phoneticUS: '/dɪˈvaɪd/', phoneticUK: '/dɪˈvaɪd/',
    meaning: '分开；除', example: 'Divide the cake.', exampleTranslation: '分蛋糕。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '➗'
  },
  {
    id: 'do', word: 'do', phoneticUS: '/duː/', phoneticUK: '/duː/',
    meaning: '做', example: 'Do your homework.', exampleTranslation: '做作业。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'doctor', word: 'doctor', phoneticUS: '/ˈdɑktər/', phoneticUK: '/ˈdɒktə/',
    meaning: '医生', example: 'My mother is a doctor.', exampleTranslation: '我妈妈是医生。',
    category: 'jobs', difficulty: 'easy', grade: '8', level: 'middle', image: '👨‍⚕️'
  },
  {
    id: 'dog', word: 'dog', phoneticUS: '/dɑɡ/', phoneticUK: '/dɒɡ/',
    meaning: '狗', example: 'I have a dog.', exampleTranslation: '我有只狗。',
    category: 'animals', difficulty: 'easy', grade: '8', level: 'middle', image: '🐕'
  },
  {
    id: 'dollar', word: 'dollar', phoneticUS: '/ˈdɑlər/', phoneticUK: '/ˈdɒlə/',
    meaning: '美元', example: 'Five dollars.', exampleTranslation: '5美元。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '💵'
  },
  {
    id: 'door', word: 'door', phoneticUS: '/dɔr/', phoneticUK: '/dɔ/',
    meaning: '门', example: 'Open the door.', exampleTranslation: '开门。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '🚪'
  },
  {
    id: 'double', word: 'double', phoneticUS: '/ˈdʌbl/', phoneticUK: '/ˈdʌbl/',
    meaning: '双倍的', example: 'Double the price.', exampleTranslation: '价格翻倍。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '×2'
  },
  {
    id: 'down', word: 'down', phoneticUS: '/daʊn/', phoneticUK: '/daʊn/',
    meaning: '向下', example: 'Sit down.', exampleTranslation: '坐下。',
    category: 'directions', difficulty: 'easy', grade: '8', level: 'middle', image: '⬇️'
  },
  {
    id: 'download', word: 'download', phoneticUS: '/ˈdaʊnloʊd/', phoneticUK: '/ˈdaʊnləʊd/',
    meaning: '下载', example: 'Download music.', exampleTranslation: '下载音乐。',
    category: 'technology', difficulty: 'medium', grade: '8', level: 'middle', image: '⬇️'
  },
  {
    id: 'downstairs', word: 'downstairs', phoneticUS: '/ˈdaʊnsterz/', phoneticUK: '/ˈdaʊnsteəz/',
    meaning: '楼下', example: 'Go downstairs.', exampleTranslation: '下楼。',
    category: 'directions', difficulty: 'easy', grade: '8', level: 'middle', image: '⬇️'
  },
  {
    id: 'draw', word: 'draw', phoneticUS: '/drɑ/', phoneticUK: '/drɔ/',
    meaning: '画', example: 'Draw a picture.', exampleTranslation: '画画。',
    category: 'hobbies', difficulty: 'easy', grade: '8', level: 'middle', image: '🎨'
  },
  {
    id: 'dream', word: 'dream', phoneticUS: '/driːm/', phoneticUK: '/driːm/',
    meaning: '梦想；梦', example: 'I have a dream.', exampleTranslation: '我有梦想。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '💭'
  },
  {
    id: 'dress', word: 'dress', phoneticUS: '/dres/', phoneticUK: '/dres/',
    meaning: '裙子；穿衣', example: 'She wears a dress.', exampleTranslation: '她穿裙子。',
    category: 'clothes', difficulty: 'easy', grade: '8', level: 'middle', image: '👗'
  },
  {
    id: 'drink', word: 'drink', phoneticUS: '/drɪŋk/', phoneticUK: '/drɪŋk/',
    meaning: '喝', example: 'Drink water.', exampleTranslation: '喝水。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🥤'
  },
  {
    id: 'drive', word: 'drive', phoneticUS: '/draɪv/', phoneticUK: '/draɪv/',
    meaning: '驾驶', example: 'Drive carefully.', exampleTranslation: '小心驾驶。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🚗'
  },
  {
    id: 'driver', word: 'driver', phoneticUS: '/ˈdraɪvər/', phoneticUK: '/ˈdraɪvə/',
    meaning: '司机', example: 'He is a driver.', exampleTranslation: '他是司机。',
    category: 'jobs', difficulty: 'easy', grade: '8', level: 'middle', image: '🚗'
  },
  {
    id: 'drop', word: 'drop', phoneticUS: '/drɑp/', phoneticUK: '/drɒp/',
    meaning: '掉落；放弃', example: 'Drop the ball.', exampleTranslation: '球掉了。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '⬇️'
  },
  {
    id: 'dry', word: 'dry', phoneticUS: '/draɪ/', phoneticUK: '/draɪ/',
    meaning: '干的', example: 'The clothes are dry.', exampleTranslation: '衣服干了。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '☀️'
  },
  {
    id: 'duck', word: 'duck', phoneticUS: '/dʌk/', phoneticUK: '/dʌk/',
    meaning: '鸭子', example: 'The duck swims.', exampleTranslation: '鸭子游泳。',
    category: 'animals', difficulty: 'easy', grade: '8', level: 'middle', image: '🦆'
  },
  {
    id: 'dumpling', word: 'dumpling', phoneticUS: '/ˈdʌmplɪŋ/', phoneticUK: '/ˈdʌmplɪŋ/',
    meaning: '饺子', example: 'I like dumplings.', exampleTranslation: '我喜欢饺子。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '🥟'
  },
  {
    id: 'during', word: 'during', phoneticUS: '/ˈdʊrɪŋ/', phoneticUK: '/ˈdʊrɪŋ/',
    meaning: '在...期间', example: 'During the summer.', exampleTranslation: '在夏天期间。',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '📅'
  },

  // E-H 基础词汇
  {
    id: 'each', word: 'each', phoneticUS: '/iːtʃ/', phoneticUK: '/iːtʃ/',
    meaning: '每个', example: 'Each student.', exampleTranslation: '每个学生。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👤'
  },
  {
    id: 'ear', word: 'ear', phoneticUS: '/ɪr/', phoneticUK: '/ɪə/',
    meaning: '耳朵', example: 'I have two ears.', exampleTranslation: '我有两只耳朵。',
    category: 'body', difficulty: 'easy', grade: '8', level: 'middle', image: '👂'
  },
  {
    id: 'early', word: 'early', phoneticUS: '/ˈɜrli/', phoneticUK: '/ˈɜli/',
    meaning: '早的', example: 'I wake up early.', exampleTranslation: '我早起。',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '🌅'
  },
  {
    id: 'earth', word: 'earth', phoneticUS: '/ɜrθ/', phoneticUK: '/ɜθ/',
    meaning: '地球', example: 'Earth is our home.', exampleTranslation: '地球是我们的家。',
    category: 'nature', difficulty: 'easy', grade: '8', level: 'middle', image: '🌍'
  },
  {
    id: 'east', word: 'east', phoneticUS: '/iːst/', phoneticUK: '/iːst/',
    meaning: '东方', example: 'The sun rises in the east.', exampleTranslation: '太阳从东方升起。',
    category: 'directions', difficulty: 'easy', grade: '8', level: 'middle', image: '🌅'
  },
  {
    id: 'easy', word: 'easy', phoneticUS: '/ˈiːzi/', phoneticUK: '/ˈiːzi/',
    meaning: '容易的', example: 'This is easy.', exampleTranslation: '这很容易。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'eat', word: 'eat', phoneticUS: '/iːt/', phoneticUK: '/iːt/',
    meaning: '吃', example: 'Eat breakfast.', exampleTranslation: '吃早餐。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🍽️'
  },
  {
    id: 'egg', word: 'egg', phoneticUS: '/eɡ/', phoneticUK: '/eɡ/',
    meaning: '鸡蛋', example: 'I eat eggs.', exampleTranslation: '我吃鸡蛋。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '🥚'
  },
  {
    id: 'eight', word: 'eight', phoneticUS: '/eɪt/', phoneticUK: '/eɪt/',
    meaning: '八', example: 'I am eight years old.', exampleTranslation: '我8岁。',
    category: 'numbers', difficulty: 'easy', grade: '8', level: 'middle', image: '8️⃣'
  },
  {
    id: 'eighteen', word: 'eighteen', phoneticUS: '/eɪˈtiːn/', phoneticUK: '/eɪˈtiːn/',
    meaning: '十八', example: 'I am eighteen.', exampleTranslation: '我18岁。',
    category: 'numbers', difficulty: 'easy', grade: '8', level: 'middle', image: '1️⃣8️⃣'
  },
  {
    id: 'eighty', word: 'eighty', phoneticUS: '/ˈeɪti/', phoneticUK: '/ˈeɪti/',
    meaning: '八十', example: 'My grandma is eighty.', exampleTranslation: '我奶奶80岁。',
    category: 'numbers', difficulty: 'easy', grade: '8', level: 'middle', image: '8️⃣0️⃣'
  },
  {
    id: 'either', word: 'either', phoneticUS: '/ˈiðər/', phoneticUK: '/ˈaɪðə/',
    meaning: '两者之一', example: 'You can choose either.', exampleTranslation: '你可以选择任一个。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '✌️'
  },
  {
    id: 'elephant', word: 'elephant', phoneticUS: '/ˈelɪfənt/', phoneticUK: '/ˈelɪfənt/',
    meaning: '大象', example: 'The elephant is big.', exampleTranslation: '大象很大。',
    category: 'animals', difficulty: 'easy', grade: '8', level: 'middle', image: '🐘'
  },
  {
    id: 'eleven', word: 'eleven', phoneticUS: '/ɪˈlevən/', phoneticUK: '/ɪˈlevən/',
    meaning: '十一', example: 'I am eleven.', exampleTranslation: '我11岁。',
    category: 'numbers', difficulty: 'easy', grade: '8', level: 'middle', image: '1️⃣1️⃣'
  },
  {
    id: 'email', word: 'email', phoneticUS: '/ˈiːmeɪl/', phoneticUK: '/ˈiːmeɪl/',
    meaning: '电子邮件', example: 'Send me an email.', exampleTranslation: '给我发邮件。',
    category: 'technology', difficulty: 'easy', grade: '8', level: 'middle', image: '📧'
  },
  {
    id: 'empty', word: 'empty', phoneticUS: '/ˈempti/', phoneticUK: '/ˈempti/',
    meaning: '空的', example: 'The bottle is empty.', exampleTranslation: '瓶子是空的。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🥤'
  },
  {
    id: 'encourage', word: 'encourage', phoneticUS: '/ɪnˈkɜrɪdʒ/', phoneticUK: '/ɪnˈkɜrɪdʒ/',
    meaning: '鼓励', example: 'Encourage your friends.', exampleTranslation: '鼓励你的朋友。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '💪'
  },
  {
    id: 'end', word: 'end', phoneticUS: '/end/', phoneticUK: '/end/',
    meaning: '结束', example: 'The end of the story.', exampleTranslation: '故事的结尾。',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '🔚'
  },
  {
    id: 'enemy', word: 'enemy', phoneticUS: '/ˈenəmi/', phoneticUK: '/ˈenəmi/',
    meaning: '敌人', example: 'Make no enemies.', exampleTranslation: '不要树敌。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⚔️'
  },
  {
    id: 'energy', word: 'energy', phoneticUS: '/ˈenərdʒi/', phoneticUK: '/ˈenədʒi/',
    meaning: '能量', example: 'I have energy.', exampleTranslation: '我有能量。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⚡'
  },
  {
    id: 'engineer', word: 'engineer', phoneticUS: '/ˌendʒɪˈnɪr/', phoneticUK: '/ˌendʒɪˈnɪə/',
    meaning: '工程师', example: 'My father is an engineer.', exampleTranslation: '我爸爸是工程师。',
    category: 'jobs', difficulty: 'medium', grade: '8', level: 'middle', image: '👷'
  },
  {
    id: 'enjoy', word: 'enjoy', phoneticUS: '/ɪnˈdʒɔɪ/', phoneticUK: '/ɪnˈdʒɔɪ/',
    meaning: '享受', example: 'Enjoy your life.', exampleTranslation: '享受生活。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '😊'
  },
  {
    id: 'enough', word: 'enough', phoneticUS: '/ɪˈnʌf/', phoneticUK: '/ɪˈnʌf/',
    meaning: '足够的', example: 'I have enough time.', exampleTranslation: '我有足够的时间。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'enter', word: 'enter', phoneticUS: '/ˈentər/', phoneticUK: '/ˈentə/',
    meaning: '进入', example: 'Enter the room.', exampleTranslation: '进入房间。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🚶'
  },
  {
    id: 'environment', word: 'environment', phoneticUS: '/ɪnˈvaɪrənmənt/', phoneticUK: '/ɪnˈvaɪrənmənt/',
    meaning: '环境', example: 'Protect the environment.', exampleTranslation: '保护环境。',
    category: 'nature', difficulty: 'hard', grade: '8', level: 'middle', image: '🌿'
  },
  {
    id: 'eraser', word: 'eraser', phoneticUS: '/ɪˈreɪsər/', phoneticUK: '/ɪˈreɪzə/',
    meaning: '橡皮', example: 'Use an eraser.', exampleTranslation: '用橡皮。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '🧽'
  },
  {
    id: 'especially', word: 'especially', phoneticUS: '/ɪˈspeʃəli/', phoneticUK: '/ɪˈspeʃəli/',
    meaning: '特别', example: 'I especially like music.', exampleTranslation: '我特别喜欢音乐。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⭐'
  },
  {
    id: 'Europe', word: 'Europe', phoneticUS: '/ˈjʊrəp/', phoneticUK: '/ˈjʊrəp/',
    meaning: '欧洲', example: 'I want to visit Europe.', exampleTranslation: '我想去欧洲。',
    category: 'places', difficulty: 'medium', grade: '8', level: 'middle', image: '🌍'
  },
  {
    id: 'European', word: 'European', phoneticUS: '/ˌjʊrəˈpiːən/', phoneticUK: '/ˌjʊrəˈpiːən/',
    meaning: '欧洲的', example: 'European culture.', exampleTranslation: '欧洲文化。',
    category: 'society', difficulty: 'medium', grade: '8', level: 'middle', image: '🌍'
  },
  {
    id: 'even', word: 'even', phoneticUS: '/ˈiːvən/', phoneticUK: '/ˈiːvən/',
    meaning: '甚至', example: 'Even a child knows.', exampleTranslation: '连孩子都知道。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '❗'
  },
  {
    id: 'evening', word: 'evening', phoneticUS: '/ˈiːvnɪŋ/', phoneticUK: '/ˈiːvnɪŋ/',
    meaning: '傍晚', example: 'Good evening!', exampleTranslation: '晚上好！',
    category: 'time', difficulty: 'easy', grade: '8', level: 'middle', image: '🌙'
  },
  {
    id: 'event', word: 'event', phoneticUS: '/ɪˈvent/', phoneticUK: '/ɪˈvent/',
    meaning: '事件', example: 'This is a big event.', exampleTranslation: '这是个大事件。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '📅'
  },
  {
    id: 'ever', word: 'ever', phoneticUS: '/ˈevər/', phoneticUK: '/ˈevə/',
    meaning: '曾经', example: 'Have you ever been?', exampleTranslation: '你曾经去过吗？',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '❓'
  },
  {
    id: 'every', word: 'every', phoneticUS: '/ˈevri/', phoneticUK: '/ˈevri/',
    meaning: '每个', example: 'Every student.', exampleTranslation: '每个学生。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'everybody', word: 'everybody', phoneticUS: '/ˈevribɑdi/', phoneticUK: '/ˈevribɒdi/',
    meaning: '每个人', example: 'Everybody is here.', exampleTranslation: '每个人都在这里。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👥'
  },
  {
    id: 'everyday', word: 'everyday', phoneticUS: '/ˈevrideɪ/', phoneticUK: '/ˈevrideɪ/',
    meaning: '每天的', example: 'Everyday life.', exampleTranslation: '日常生活。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📅'
  },
  {
    id: 'everyone', word: 'everyone', phoneticUS: '/ˈevriwʌn/', phoneticUK: '/ˈevriwʌn/',
    meaning: '每个人', example: 'Everyone likes music.', exampleTranslation: '每个人都喜欢音乐。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👥'
  },
  {
    id: 'everything', word: 'everything', phoneticUS: '/ˈevriθɪŋ/', phoneticUK: '/ˈevriθɪŋ/',
    meaning: '一切', example: 'Everything is ready.', exampleTranslation: '一切都准备好了。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'everywhere', word: 'everywhere', phoneticUS: '/ˈevriwer/', phoneticUK: '/ˈevriweə/',
    meaning: '到处', example: 'I look everywhere.', exampleTranslation: '我到处找。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🌍'
  },
  {
    id: 'exam', word: 'exam', phoneticUS: '/ɪɡˈzæm/', phoneticUK: '/ɪɡˈzæm/',
    meaning: '考试', example: 'I have an exam.', exampleTranslation: '我有考试。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '📝'
  },
  {
    id: 'examination', word: 'examination', phoneticUS: '/ɪɡˌzæmɪˈneɪʃn/', phoneticUK: '/ɪɡˌzæmɪˈneɪʃn/',
    meaning: '考试；检查', example: 'Take an examination.', exampleTranslation: '参加考试。',
    category: 'school', difficulty: 'hard', grade: '8', level: 'middle', image: '📝'
  },
  {
    id: 'example', word: 'example', phoneticUS: '/ɪɡˈzæmpl/', phoneticUK: '/ɪɡˈzæmpl/',
    meaning: '例子', example: 'Give an example.', exampleTranslation: '举个例子。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '💡'
  },
  {
    id: 'excellent', word: 'excellent', phoneticUS: '/ˈeksələnt/', phoneticUK: '/ˈeksələnt/',
    meaning: '优秀的', example: 'Excellent work!', exampleTranslation: '优秀的工作！',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🏆'
  },
  {
    id: 'except', word: 'except', phoneticUS: '/ɪkˈsept/', phoneticUK: '/ɪkˈsept/',
    meaning: '除了', example: 'Everyone except me.', exampleTranslation: '除了我以外的所有人。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '≠'
  },
  {
    id: 'excite', word: 'excite', phoneticUS: '/ɪkˈsaɪt/', phoneticUK: '/ɪkˈsaɪt/',
    meaning: '使兴奋', example: 'The news excites me.', exampleTranslation: '这消息让我兴奋。',
    category: 'emotions', difficulty: 'medium', grade: '8', level: 'middle', image: '🎉'
  },
  {
    id: 'excited', word: 'excited', phoneticUS: '/ɪkˈsaɪtɪd/', phoneticUK: '/ɪkˈsaɪtɪd/',
    meaning: '兴奋的', example: 'I am excited.', exampleTranslation: '我很兴奋。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '😃'
  },
  {
    id: 'exciting', word: 'exciting', phoneticUS: '/ɪkˈsaɪtɪŋ/', phoneticUK: '/ɪkˈsaɪtɪŋ/',
    meaning: '令人兴奋的', example: 'This is exciting.', exampleTranslation: '这很令人兴奋。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '🎉'
  },
  {
    id: 'excuse', word: 'excuse', phoneticUS: '/ɪkˈskjuːz/', phoneticUK: '/ɪkˈskjuːz/',
    meaning: '借口；原谅', example: 'Excuse me.', exampleTranslation: '打扰了。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🙏'
  },
  {
    id: 'exercise', word: 'exercise', phoneticUS: '/ˈeksərsaɪz/', phoneticUK: '/ˈeksəsaɪz/',
    meaning: '运动；练习', example: 'Do exercise.', exampleTranslation: '做运动。',
    category: 'sports', difficulty: 'easy', grade: '8', level: 'middle', image: '🏃'
  },
  {
    id: 'expect', word: 'expect', phoneticUS: '/ɪkˈspekt/', phoneticUK: '/ɪkˈspekt/',
    meaning: '期待', example: 'I expect you.', exampleTranslation: '我期待你。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⏰'
  },
  {
    id: 'expensive', word: 'expensive', phoneticUS: '/ɪkˈspensɪv/', phoneticUK: '/ɪkˈspensɪv/',
    meaning: '昂贵的', example: 'This is expensive.', exampleTranslation: '这很贵。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '💰'
  },
  {
    id: 'experience', word: 'experience', phoneticUS: '/ɪkˈspɪriəns/', phoneticUK: '/ɪkˈspɪriəns/',
    meaning: '经验；经历', example: 'I have experience.', exampleTranslation: '我有经验。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '📚'
  },
  {
    id: 'experiment', word: 'experiment', phoneticUS: '/ɪkˈsperɪmənt/', phoneticUK: '/ɪkˈsperɪmənt/',
    meaning: '实验', example: 'Do an experiment.', exampleTranslation: '做实验。',
    category: 'science', difficulty: 'medium', grade: '8', level: 'middle', image: '🧪'
  },
  {
    id: 'explain', word: 'explain', phoneticUS: '/ɪkˈspleɪn/', phoneticUK: '/ɪkˈspleɪn/',
    meaning: '解释', example: 'Explain the answer.', exampleTranslation: '解释答案。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '💡'
  },
  {
    id: 'express', word: 'express', phoneticUS: '/ɪkˈspres/', phoneticUK: '/ɪkˈspres/',
    meaning: '表达', example: 'Express your ideas.', exampleTranslation: '表达你的想法。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '💬'
  },
  {
    id: 'eye', word: 'eye', phoneticUS: '/aɪ/', phoneticUK: '/aɪ/',
    meaning: '眼睛', example: 'I have two eyes.', exampleTranslation: '我有两只眼睛。',
    category: 'body', difficulty: 'easy', grade: '8', level: 'middle', image: '👁️'
  },
];

export default grade8Vocabulary;